import styled from 'styled-components';
import { BG_KAMBAM_RECOLOCATION } from 'utils/CONSTANTS';


export const ColumnCount = styled.span`
  display: inline-block;
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 12px;
  margin-left: 8px;
`;

export const LoadMoreButton = styled.button`
  width: 100%;
  padding: 10px;
  margin-top: 4px;
  margin-bottom: 12px;
  border: 1px dashed ${({ theme }) => theme.colors.secondaryDark};
  border-radius: 8px;
  background: transparent;
  color: ${({ theme }) => theme.colors.secondaryDark};
  font-family: ${({ theme }) => theme.fontFamily.poppins};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 200ms ease, opacity 200ms ease;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.secondaryDark}15;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const KamBamTitle = styled.h4<{ id: number }>`
  color: ${({ theme }) => theme.colors.white};
  font-size: 16px;
  font-family: ${({ theme }) => theme.fontFamily.poppins} !important;
  border-radius: 5px; 
  padding: 12px !important;
  width: 100% !important;
  margin-bottom: 25px;
  background-color: ${({theme, id}) => BG_KAMBAM_RECOLOCATION[id] || theme.colors.blue} !important;
  cursor: pointer;
  transform: scale(1);
  transition: transform 350ms ease;


  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: scale(1.05)
    }
  }
`;
